import React from 'react'
export default function DashboardCommonCard({ title, value, icon, isValueBold = true }) {
  return (
    <div className="mb-3">
      <div className="shadow-sm border-0 rounded-3 p-1 mb-2">
        <div className="card-body p-0">
          <p className="text-muted mb-2 small fw-normal">{title}</p>
          <h2 className={`mb-0 fs-4 ${isValueBold ? "fw-bold" : "fw-normal"}`}>{value}</h2>
        </div>
      </div>
    </div>
  )
}